import React from "react";
import {css} from "@panda/css";

import {InfoIcon} from "@pg-design/icons-module";
import {Popover} from "@pg-design/notifications";
import {Text} from "@pg-design/text-module";

interface IProps {
    dataTestId?: string;
    icon: React.ReactNode;
    label: string;
    value: React.ReactNode;
    popover?: React.ReactNode;
}

export const UVP = (props: IProps) => {
    return (
        <div className={uvpStyle}>
            {props.icon}
            <div className={contentStyle}>
                <Text variant="info_txt_1" align="center">
                    {props.label}
                </Text>

                <div className={valueRowStyle}>
                    <Text variant="body_copy_1" strong align="center" className={uvpValueStyle} dataTestId={props.dataTestId}>
                        {props.value}
                    </Text>

                    {props.popover && (
                        <Popover isActive popoverPlace="bottom" body={<>{props.popover}</>} toggleClickHandler toggleOnClickOutside inline type="action">
                            <InfoIcon className={infoIconStyle} size="1.8" />
                        </Popover>
                    )}
                </div>
            </div>
        </div>
    );
};

const uvpStyle = css({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    gap: 3,
    w: "50%",
    h: "130px",
    md: {
        w: "130px"
    }
});

const contentStyle = css({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    whiteSpace: "nowrap"
});

const valueRowStyle = css({
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});

const uvpValueStyle = css({
    whiteSpace: "normal",
    h: "2rem"
});

const infoIconStyle = css({
    ml: 1,
    cursor: "pointer"
});
import React from "react";
import {css} from "@panda/css";

import {InfoIcon} from "@pg-design/icons-module";
import {Popover} from "@pg-design/notifications";
import {Text} from "@pg-design/text-module";

interface IProps {
    dataTestId?: string;
    icon: React.ReactNode;
    label: string;
    value: React.ReactNode;
    popover?: React.ReactNode;
}

export const UVP = (props: IProps) => {
    return (
        <div className={uvpStyle}>
            {props.icon}
            <div className={contentStyle}>
                <Text variant="info_txt_1" align="center">
                    {props.label}
                </Text>

                <div className={valueRowStyle}>
                    <Text variant="body_copy_1" strong align="center" className={uvpValueStyle} dataTestId={props.dataTestId}>
                        {props.value}
                    </Text>

                    {props.popover && (
                        <Popover isActive popoverPlace="bottom" body={<>{props.popover}</>} toggleClickHandler toggleOnClickOutside inline type="action">
                            <InfoIcon className={infoIconStyle} size="1.8" />
                        </Popover>
                    )}
                </div>
            </div>
        </div>
    );
};

const uvpStyle = css({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    gap: 3,
    w: "50%",
    h: "130px",
    md: {
        w: "130px"
    }
});

const contentStyle = css({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    whiteSpace: "nowrap"
});

const valueRowStyle = css({
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});

const uvpValueStyle = css({
    whiteSpace: "normal",
    h: "2rem"
});

const infoIconStyle = css({
    ml: 1,
    cursor: "pointer"
});
